import { IconButton } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { memo, useCallback } from 'react';
import { UserPreferenceName } from '@/modules/userPreferences';
import { useUpdateUserPreferences } from '@/modules/userPreferences/hooks';
import { StyledTooltip } from '@/modules/common/components/StyledTooltip';
import { theme } from '@/modules/common/theme';

type Props = {
  preference: UserPreferenceName;
};

const ResetUserPreferenceButtonComponent = ({ preference }: Props) => {
  const { resetUserPreference } = useUpdateUserPreferences();

  const onReset = useCallback(() => {
    resetUserPreference(preference);
  }, [resetUserPreference, preference]);

  return (
    <StyledTooltip title='Reset to default'>
      <IconButton
        onClick={onReset}
        size='small'
        sx={{
          color: theme.palette.neutral.dark,
          '&:hover': { color: theme.palette.neutral.darker },
        }}
      >
        <RestartAltIcon fontSize='small' />
      </IconButton>
    </StyledTooltip>
  );
};

export const ResetUserPreferenceButton = memo(ResetUserPreferenceButtonComponent);
